  <div class="calendar">
    <div class="month">
      <div class="date">
        <span class="calendar-title"
          ><span
            appList
            [listData]="months"
            [selected]="date.getMonth()"
            (selectMonth)="setMonth($event)"
            (isOpen)="isOpenedMonth($event)"
            >{{ months[date.getMonth()] }}
            @if (isOpenMonth) {
              <mat-icon>arrow_drop_up</mat-icon>
            } @else {
              <mat-icon>arrow_drop_down</mat-icon>
            }
          </span>
          <span
            appList
            [listData]="getYearRange()"
            [selected]="15"
            (selectYear)="setYear($event)"
            (isOpen)="isOpenedYear($event)"
            >{{ date.getFullYear() }}
            @if (isOpenYear) {
              <mat-icon>arrow_drop_up</mat-icon>
            } @else {
              <mat-icon>arrow_drop_down</mat-icon>
            }
          </span>
        </span>
      </div>
      <div class="icons">
        <span class="cal-icon" (click)="prev()">
          <mat-icon>chevron_left</mat-icon>
        </span>
        <span class="cal-icon" (click)="next()">
          <mat-icon>chevron_right</mat-icon>
        </span>
      </div>
    </div>
    <div class="weekdays">
      <div class="weekday-header">{{ days[0] }}</div>
      <div class="weekday-header">{{ days[1] }}</div>
      <div class="weekday-header">{{ days[2] }}</div>
      <div class="weekday-header">{{ days[3] }}</div>
      <div class="weekday-header">{{ days[4] }}</div>
      <div class="weekday-header">{{ days[5] }}</div>
      <div class="weekday-header">{{ days[6] }}</div>
    </div>
    <mat-divider></mat-divider>
    <div class="days">
      <div class="prev-date" *ngFor="let day of prevDays; let i = index">
        {{ day }}
      </div>

      <div
        *ngFor="let day of currentDaysArray; let i = index"
        [ngClass]="{
          today:
            currentDay.getDate() === i + 1 &&
            date.getMonth() === currentDay.getMonth() &&
            date.getFullYear() === currentDay.getFullYear(),
          selected:
            clickedDate.getDate() === i + 1 &&
            clickedDate.getMonth() === date.getMonth() &&
            clickedDate.getFullYear() === date.getFullYear()
        }"
        [tabIndex]="1"
        (click)="setDate(i)"
      >
        {{ day.day }}
        <span
          *ngIf="day.total.hours > 0 || day.total.minutes > 0"
          class="total-hours"
          >{{ day?.total?.hours }}:{{ day?.total?.minutes }}</span
        >
      </div>

      <div class="next-date" *ngFor="let day of lastDays; let i = index">
        {{ day }}
      </div>
    </div>
    <div class="time">
      <form [formGroup]="timeForm">
        <div class="hours">
          <div class="number">
            <input
              class="time-input"
              [value]="timeForm.get('hours')?.value | number : '2.0'"
              type="number"
              [class.error]="!timeForm.get('hours')?.valid"
              formControlName="hours"
            />
            <div class="number__actions">
              <mat-icon class="arrows" (click)="increase(timeTypes.HOURS)">expand_less</mat-icon>
              <mat-icon class="arrows" (click)="decrease(timeTypes.HOURS)">expand_more</mat-icon>
            </div>
          </div>
          <mat-divider></mat-divider>
        </div>
        <span>:</span>
        <div class="hours">
          <div class="number">
            <input
              class="time-input"
              [value]="timeForm.get('minutes')?.value | number : '2.0'"
              type="number"
              [class.error]="!timeForm.get('minutes')?.valid"
              formControlName="minutes"
            />
            <div class="number__actions">
              <mat-icon class="arrows" (click)="increase(timeTypes.MINUTES)">expand_less</mat-icon>
              <mat-icon class="arrows" (click)="decrease(timeTypes.MINUTES)">expand_more</mat-icon>
            </div>
          </div>
          <mat-divider></mat-divider>
        </div>
      </form>
    </div>
    <div class="buttons">
      <button mat-flat-button color="primary" [disabled]="!clickedDate || !timeForm.valid" (click)="confirm()">OK</button>
    </div>
  </div>
